'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _a;
(function (Direction) {
    Direction["Right"] = "right";
    Direction["Left"] = "left";
    Direction["Up"] = "up";
    Direction["Down"] = "down";
})(exports.Direction || (exports.Direction = {}));
var RotationDegrees = (_a = {},
    _a[exports.Direction.Right] = 'rotate(225deg)',
    _a[exports.Direction.Left] = 'rotate(45deg)',
    _a[exports.Direction.Up] = 'rotate(135deg)',
    _a[exports.Direction.Down] = 'rotate(315deg)',
    _a);
var ArrowIcon = styled__default['default'].span.withConfig({
    shouldForwardProp: function (prop) { return !['direction', 'size', 'area'].includes(prop); },
})(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n    color: ", ";\n    display: inline-block;\n    border-left: 1px solid;\n    border-bottom: 1px solid;\n    ", "\n"], ["\n    color: ", ";\n    display: inline-block;\n    border-left: 1px solid;\n    border-bottom: 1px solid;\n    ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
}, function (_a) {
    var _b = _a.direction, direction = _b === void 0 ? exports.Direction.Left : _b, _c = _a.size, size = _c === void 0 ? 7 : _c;
    var heightAndWidth = styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n            height: ", "px;\n            width: ", "px;\n        "], ["\n            height: ", "px;\n            width: ", "px;\n        "])), size, size);
    if (direction === exports.Direction.Up) {
        return styled.css(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n                ", "\n                transform: translateY(", "px) ", ";\n            "], ["\n                ", "\n                transform: translateY(", "px) ", ";\n            "])), heightAndWidth, size / 2, RotationDegrees[direction]);
    }
    return styled.css(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n            ", "\n            transform: ", ";\n        "], ["\n            ", "\n            transform: ", ";\n        "])), heightAndWidth, RotationDegrees[direction]);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.RotationDegrees = RotationDegrees;
exports.default = ArrowIcon;
//# sourceMappingURL=index.js.map
